import { render, staticRenderFns } from "./FilterGender.vue?vue&type=template&id=ae02c440&scoped=true&lang=pug&"
import script from "./FilterGender.vue?vue&type=script&lang=js&"
export * from "./FilterGender.vue?vue&type=script&lang=js&"
import style0 from "./FilterGender.vue?vue&type=style&index=0&id=ae02c440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae02c440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VMenu,VSpacer})
